import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-accident-support-doc',
    templateUrl: './accident-support-doc.component.html',
    styleUrls: ['./accident-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccidentSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
